<template>
  <section class="main-layout-section">
    <Preloader v-if="getPreloaderState"/>
    <Header />
    <div v-if="isBasicInfoLoaded" class="view-content mobile-first-layout">
      <router-view />
    </div>
    <Footer />
  </section>
</template>

<script>
import Preloader from '@/components/common/Preloader'
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import IconBase from '@/components/icons/IconBase'
import ResizeObserver from 'resize-observer-polyfill'

export default {
  name: 'MainLayout',
  components: { Preloader , IconBase, Footer, Header },
  data(){
    return {
      appReady: false,
      loading: true
    };
  },
  created() {
    this.$store.dispatch('fetchBasicInfo');
  },
  mounted() {
    const ro = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const cr = entry.contentRect
        this.$store.commit('setDocumentDimension', cr)
      }
    })

    // Observe one or multiple elements
    ro.observe(document.querySelector('body'))

  },
  computed: {
    isBasicInfoLoaded() {
      return this.$store.getters.isBasicInfoLoaded
    },
    getPreloaderState() {
      return this.$store.getters.getGlobalLoaderState;
    }
  },
}
</script>
